import { StyleSheet } from "aphrodite";

const Style = StyleSheet.create({
  upperFilters: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "@media (max-width: 768px)": {
      gap: "20px",
      paddingLeft: "20px",
    },
  },
  bottomFilters: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    "@media (max-width: 768px)": {
      flexWrap: "wrap",
      gap: "10px",
      paddingLeft: "20px",
      marginTop: "10px",
    },
  },
  container: {
    marginBottom: "10px",
    padding: "24px",
    boxShadow: "0px 0px 8px 0px rgba(0, 0, 0, 0.05)",
    borderRadius: "8px",
    background: "#fff",
    "@media (max-width: 768px)": {
      boxShadow: "none",
    },
  },
});

export default Style;
